import { Serializer } from "../resource/serializer.interface";
import { PreferenceWhitelist } from "./preference-whitelist.model";

export class PreferenceWhitelistSerializer implements Serializer {
    fromJson(json: any): PreferenceWhitelist {
        const channel = new PreferenceWhitelist();
        channel.id = json.id;
        channel.value = json.value;
        channel.description = json.description;
        channel.type = json.type;
        channel.status = json.status;
        channel.tenantId = json.tenant_id;
        channel.createdAt = json.createdAt;
        channel.updatedAt = json.updatedAt;
        return channel;
    }

    toJson(channel: PreferenceWhitelist): any {
        return {
            id: channel.id,
            value: channel.value,
            description: channel.description,
            type: channel.type,
            status: channel.status,
            tenant_id: channel.tenantId,
            createdAt: channel.createdAt,
            updatedAt: channel.updatedAt
        };
    }
}